import * as React from 'react';
import { HashRouter } from 'react-router-dom';
import { AuthSessionProvider } from './features/auth/AuthSession.js';
import { AppRoutes } from './routes/AppRoutes.js';

export function App() {
  return <HashRouter><AuthSessionProvider><AppRoutes /></AuthSessionProvider></HashRouter>;
}
